import { AddToCartBody, Cart, DeleteCartItemParams } from '@core/models/cart.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class CartService {
    private readonly addToCartURL = `/cart/add`;
    private readonly deleteCartItemURL = `/cart/delete`;
    private readonly getCartURL = `/cart/get-all`;
    private readonly getCartBackorderURL = `/cart/get-all/backorder`;

    // ---------------------------------------------------------------

    addToCart(body: AddToCartBody) {
        return fetchWithRetry(API.post(this.addToCartURL, body));
    }

    deleteCartItem(params: DeleteCartItemParams) {
        return fetchWithRetry(API.patch(`${this.deleteCartItemURL}/productId=${params.productId}`, null, { params: { quantity: params.quantity } }));
    }

    getCart() {
        return fetchWithRetry(API.get<Cart>(this.getCartURL));
    }

    getCartBackorder() {
        return fetchWithRetry(API.get<Cart>(this.getCartBackorderURL));
    }
}

export default new CartService();

